module["exports"] = ["#####", "### ##", "## ###"];